module.exports = function getResource(label) {
    let resources = {
        seeItInRealLife: 'See It in Real Life',
        addYourPhoto: '+ Add your photo',
        addAPhoto: 'Add a photo',
        sorryNoImages: 'Sorry, no images match the applied filters.'
    };
    return resources[label];
};
